"use client";

import Image from "next/image";
import Link from "next/link";
import { FaWhatsapp, FaLinkedin, FaXTwitter } from "react-icons/fa6";

export default function HomeContent() {
  return (
    <div className="overflow-hidden">
      <div>
        <div className="bg-white">
          {/* First Section */}
          <section className="bg-[#4887f5]">
            <div className="rounded-b-semifull xsm:pb-10 bg-[#E9E9EA] pb-10 sm:pb-12 md:pb-14 lg:pb-16 xl:pb-20">
              <div className="rounded-b-semifull relative bg-[#27335d] py-16 text-white">
                {/* Main Content */}
                <div data-testid="homeHeroHeading" className="mx-auto flex w-fit flex-col items-start justify-center pb-10 text-start sm:pb-14 md:mt-5 md:pb-22 lg:mt-14">
                  <p className="xsm:text-xl text-xl font-bold sm:text-2xl md:text-5xl lg:text-6xl xl:text-7xl">
                    Discover how simple, fun, and
                  </p>
                  <p className="xsm:text-xl text-xl font-bold sm:text-2xl md:text-5xl lg:text-6xl xl:text-7xl">
                    convenient learning{" "}
                    <span>
                      <Image
                        src={"/images/svg/arabic.svg"}
                        alt={"Arabic"}
                        height={60}
                        width={60}
                        className="mx-auto mt-1 inline-block h-8 w-auto sm:h-10 sm:w-auto md:h-[75px] md:w-auto lg:h-[110px] lg:w-auto xl:h-[130px] xl:w-auto"
                      />
                    </span>
                  </p>
                  <p className="xsm:text-xl text-xl font-bold sm:text-2xl md:text-5xl lg:text-6xl xl:text-7xl">
                    can be!
                  </p>
                </div>

                {/* Get started Button */}
                <div className="xsm:pb-16 mt-4 flex flex-row justify-center pb-16 sm:pb-20 md:mt-4 md:pb-28 lg:pb-28">
                  <Link href="/register" data-testid="homeGetStartedButton" className="inline-block transform-gpu rounded-full border-b-8 border-[#0c0f1c] bg-[#4887F5] px-8 py-[12px] text-lg font-bold text-[#27335d] shadow-2xl transition-all duration-300 ease-out hover:bg-[#3666b9] active:scale-95 sm:px-10 sm:py-[14px] sm:text-xl md:px-12 md:py-[16px] md:text-2xl lg:px-14 lg:py-6 lg:text-2xl">
                      Get started today
                  </Link>
                </div>

                {/* Yalla Image */}
                <div className="absolute -bottom-10 left-1/2 -translate-x-1/2 transform sm:-bottom-12 sm:left-1/2 sm:-translate-x-1/2 sm:transform md:right-[12%] md:-bottom-[53px] md:left-auto md:transform-none lg:right-[15%] lg:-bottom-[67px] lg:left-auto lg:transform-none xl:right-[10.5%] xl:-bottom-[77px] xl:left-auto xl:transform-none">
                  <Image
                    src="/images/svg/yalla2.svg"
                    alt="Yalla"
                    width={100}
                    height={100}
                    className="h-[150px] w-[150px] object-contain sm:h-[180px] sm:w-[180px] md:h-[200px] md:w-[200px] lg:h-[250px] lg:w-[250px] xl:h-[290px] xl:w-[290px]"
                  />
                </div>
              </div>
            </div>
          </section>
          {/* Second Section */}
          <section className="bg-[#27335d]">
            <div className="rounded-b-semifull xsm:pb-10 bg-[#E9E9EA] pb-10 sm:pb-12 md:pb-14 lg:pb-16 xl:pb-20">
              <div className="rounded-b-semifull xsm:py-10 bg-[#4887f5] py-10 sm:py-12 md:py-14 lg:py-16 xl:py-20">
                {/* Intro */}
                <div className="text-center">
                  <h1 className="xsm:text-xl text-xl font-bold tracking-tight text-white sm:text-2xl md:text-5xl lg:text-6xl xl:text-7xl">
                    Fluency in Arabic,{" "}
                  </h1>
                  <h1 className="xsm:text-xl text-xl font-bold tracking-tight text-white sm:text-2xl md:text-5xl lg:text-6xl xl:text-7xl">
                    Simplified
                  </h1>
                </div>
                {/* Cards */}
                <div className="xsm:mb-10 xsm:mt-12 xsm:gap-12 mt-12 mb-10 flex flex-wrap justify-center gap-12 sm:mt-14 sm:mb-12 sm:gap-14 md:mt-16 md:mb-14 md:gap-14 lg:mt-20 lg:mb-16 lg:gap-9 xl:mt-24 xl:mb-20 xl:gap-24">
                  {/* Card 1 */}
                  <div className="rounded-9xl xsm:min-h-[220px] xsm:w-[230px] flex min-h-[200px] w-[200px] flex-col items-center justify-center border-b-8 border-[#16294a] text-center sm:min-h-[240px] sm:w-[250px] md:min-h-[250px] md:w-[265px] lg:min-h-[250px] lg:w-[265px]">
                    <div data-testid="featureCard1" className="rounded-9xl xsm:min-h-[220px] xsm:w-[230px] flex min-h-[200px] w-[200px] flex-col items-center justify-center border-4 border-[#4887f5] bg-[#27335d] py-4 text-center sm:min-h-[240px] sm:w-[250px] md:min-h-[250px] md:w-[265px] lg:min-h-[250px] lg:w-[265px]">
                      <div className="px-6">
                        <Image
                          src="/images/icon1.svg"
                          alt="Expert Teachers"
                          height={100}
                          width={100}
                          className="xsm:h-11 xsm:w-11 mx-auto mt-2 h-10 w-10 sm:h-12 sm:w-12 md:h-14 md:w-14 lg:h-16 lg:w-16 xl:h-14 xl:w-14"
                        />
                        <h1 className="xsm:text-lg mt-3 mb-2.5 text-base font-bold text-white sm:text-xl md:text-xl lg:text-xl xl:text-xl">
                          Expert Teachers
                        </h1>
                        <span className="xsm:text-sm text-xs font-medium text-white sm:text-base md:text-base lg:text-lg xl:text-base">
                          Work with our expert teachers to kickstart your journey
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 2 */}
                  <div className="rounded-9xl xsm:min-h-[220px] xsm:w-[230px] flex min-h-[200px] w-[200px] flex-col items-center justify-center border-b-8 border-[#16294a] text-center sm:min-h-[240px] sm:w-[250px] md:min-h-[250px] md:w-[265px] lg:min-h-[250px] lg:w-[265px]">
                    <div data-testid="featureCard2" className="rounded-9xl xsm:min-h-[220px] xsm:w-[230px] flex min-h-[200px] w-[200px] flex-col items-center justify-center border-4 border-[#4887f5] bg-[#27335d] py-4 text-center sm:min-h-[240px] sm:w-[250px] md:min-h-[250px] md:w-[265px] lg:min-h-[250px] lg:w-[265px]">
                      <div className="px-6">
                        <Image
                          src="/images/icon2.svg"
                          alt="Learn anytime"
                          height={100}
                          width={100}
                          className="xsm:h-11 xsm:w-11 mx-auto mt-1.5 h-10 w-10 sm:h-12 sm:w-12 md:h-14 md:w-14 lg:h-16 lg:w-16 xl:h-14 xl:w-14"
                        />
                        <h1 className="xsm:text-lg mt-3 mb-2.5 text-base font-bold text-white sm:text-xl md:text-xl lg:text-xl xl:text-xl">
                          Learn Anytime
                        </h1>
                        <span className="xsm:text-sm text-xs font-medium text-white sm:text-base md:text-base lg:text-lg xl:text-base">
                          Take online lessons at the perfect time for your busy schedule
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Card 3 */}
                  <div className="rounded-9xl xsm:min-h-[220px] xsm:w-[230px] flex min-h-[200px] w-[200px] flex-col items-center justify-center border-b-8 border-[#16294a] text-center sm:min-h-[240px] sm:w-[250px] md:min-h-[250px] md:w-[265px] lg:min-h-[250px] lg:w-[265px]">
                    <div data-testid="featureCard3" className="rounded-9xl xsm:min-h-[220px] xsm:w-[230px] flex min-h-[200px] w-[200px] flex-col items-center justify-center border-4 border-[#4887f5] bg-[#27335d] py-4 text-center sm:min-h-[240px] sm:w-[250px] md:min-h-[250px] md:w-[265px] lg:min-h-[250px] lg:w-[265px]">
                      <div className="px-6">
                        <Image
                          src="/images/icon3.svg"
                          alt="Flexible Prices"
                          height={100}
                          width={100}
                          className="xsm:h-11 xsm:w-11 mx-auto h-10 w-10 sm:h-12 sm:w-12 md:h-14 md:w-14 lg:h-16 lg:w-16 xl:h-14 xl:w-14"
                        />
                        <h1 className="xsm:text-lg mt-3 mb-2.5 text-base font-bold text-white sm:text-xl md:text-xl lg:text-xl xl:text-xl">
                          Flexible Prices
                        </h1>
                        <span className="xsm:text-sm text-xs font-medium text-white sm:text-base md:text-base lg:text-lg xl:text-base">
                          Choose an experienced teacher that fits your budget
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Third Section */}
          <section className="bg-[#ef7e74]">
            {/* Section Container */}
            <div className="rounded-b-semifull xsm:pb-8 bg-[#E9E9EA] pb-8 sm:pb-10 md:pb-12 lg:pb-14 xl:pb-16">
              <div className="rounded-b-semifull xsm:py-8 bg-[#27335d] py-8 text-white sm:py-10 md:py-16 lg:py-20 xl:py-24">
                {/* Intro */}
                <div className="xsm:mb-6 mx-auto mb-6 flex w-[80%] flex-row items-center justify-start sm:mb-7 md:mb-8 lg:mt-8 lg:mb-9 xl:mt-10 xl:mb-10">
                  <div className="text-start">
                    <h1 className="xsm:text-xl pb-3 text-xl font-bold tracking-tight text-white sm:text-2xl md:pb-8 md:text-5xl lg:text-6xl xl:text-7xl">
                      Your Arabic Learning{" "}
                      <span className="block">Toolkit</span>
                    </h1>
                  </div>
                </div>
                {/* Toolkit Items */}
                <div className="flex flex-col items-center justify-center">
                  <div className="xsm:px-5 xsm:py-7 flex flex-col items-center gap-4 rounded-2xl border-4 border-[#4887F5] px-5 py-7 sm:gap-6 sm:px-[1.4rem] sm:py-8 md:gap-10 md:px-20 md:py-16">
                    {/* Toolkit Item 1 */}
                    <div className="xsm:text-[0.645rem] flex h-[50px] w-[240px] items-center justify-center rounded-[15px] border-2 border-[#27335D] bg-[#FFF1D2] px-3 text-[0.645rem] font-bold text-[#27305D] sm:h-[62px] sm:w-[310px] sm:text-[0.8rem] md:h-[92px] md:w-[500px] md:text-lg lg:h-[92px] lg:w-[597px] lg:text-2xl">
                      Personal Tutoring, Your Way
                    </div>

                    {/* Toolkit Item 2 */}
                    <div className="xsm:text-[0.645rem] flex h-[50px] w-[240px] items-center justify-center rounded-[15px] border-2 border-[#27335D] bg-[#FCE8BD] px-3 text-[0.645rem] font-bold text-[#27305D] sm:h-[62px] sm:w-[310px] sm:text-[0.8rem] md:h-[92px] md:w-[500px] md:text-lg lg:h-[92px] lg:w-[597px] lg:text-2xl">
                      A Library Full of Learning Goodies
                    </div>

                    {/* Toolkit Item 3 */}
                    <div className="xsm:text-[0.645rem] flex h-[50px] w-[240px] items-center justify-center rounded-[15px] border-2 border-[#27335D] bg-[#F9D17B] px-3 text-[0.645rem] font-bold text-[#27305D] sm:h-[62px] sm:w-[310px] sm:text-[0.8rem] md:h-[92px] md:w-[500px] md:text-lg lg:h-[92px] lg:w-[597px] lg:text-2xl">
                      Track Your Growth, Celebrate Success
                    </div>

                    {/* Toolkit Item 4 */}
                    <div className="xsm:text-[0.645rem] flex h-[50px] w-[240px] items-center justify-center rounded-[15px] border-2 border-[#27335D] bg-[#F7C65A] px-3 text-[0.645rem] font-bold text-[#27305D] sm:h-[62px] sm:w-[310px] sm:text-[0.8rem] md:h-[92px] md:w-[500px] md:text-lg lg:h-[92px] lg:w-[597px] lg:text-2xl">
                      From Marhaba to Advanced, We've Got You!
                    </div>
                  </div>

                  {/* Button Section */}
                  <div className="mt-10 flex flex-row justify-center pb-5 sm:mt-12 sm:pb-6 md:mt-16 md:pb-7">
                    <Link href="/register" data-testid="homeBecomeProButton" className="mt-4 inline-block transform-gpu rounded-full border-b-8 border-black bg-[#4887F5] px-8 py-3 text-xl font-bold text-[#27335d] shadow-2xl transition-all duration-300 ease-out hover:bg-[#3666b9] active:scale-95 sm:px-10 sm:py-4 sm:text-2xl md:px-16 md:py-6 md:text-3xl" aria-label="Become a pro in Arabic">
                        Become a pro in Arabic
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Fourth Section */}
          <section className="bg-[#27335d]">
            {/* Outer Container */}
            <div className="rounded-b-semifull bg-[#E9E9EA] pb-8 sm:pb-10 md:pb-14">
              <div className="rounded-b-semifull bg-[#ef7e74] py-8 text-white sm:py-10 md:py-16">
                {/* Header Section */}
                <div className="mx-auto ms-0 mt-6 mb-6 flex flex-col items-center px-10 sm:mt-4 sm:mb-8 md:mt-6 md:mb-12 lg:ms-36 lg:flex-row lg:items-start">
                  <h1 className="xsm:text-2xl text-2xl font-bold tracking-tight text-white sm:text-3xl md:text-5xl lg:text-6xl xl:text-7xl">
                    What Our Learners Are Saying
                  </h1>
                </div>

                {/* Testimonial Slider */}
                <div id="testimonial-slider" className="py-10">
                  <div className="testimonial-wrapper text-start">
                    <div className="testimonialLeft testimonialItem1">
                      <div className="rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <p className="max-w-xs font-bold text-black">
                          &ldquo;I now contribute and lead discussions in Arabic&rdquo;
                        </p>
                        <p className="mt-4 text-sm text-gray-500">
                          Regional Director
                        </p>
                      </div>
                    </div>
                    <div className="testimonialLeft testimonialItem2">
                      <div className="rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <p className="max-w-xs font-bold text-black">
                          &ldquo;I handle formal conversations without switching to English&rdquo;
                        </p>
                        <p className="mt-4 text-sm text-gray-500">
                          Diplomatic Mission
                        </p>
                      </div>
                    </div>
                    <div className="testimonialLeft testimonialItem3">
                      <div className="rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <p className="max-w-xs font-bold text-black">
                          &ldquo;I present and negotiate in Arabic confidently&rdquo;
                        </p>
                        <p className="mt-4 text-sm text-gray-500">
                          Founder
                        </p>
                      </div>
                    </div>
                    <div className="testimonialLeft testimonialItem4">
                      <div className="rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <p className="max-w-xs font-bold text-black">
                          &ldquo;I moved from translating… to thinking in Arabic&rdquo;
                        </p>
                        <p className="mt-4 text-sm text-gray-500">
                          PhD Researcher
                        </p>
                      </div>
                    </div>
                    <div className="testimonialLeft testimonialItem5">
                      <div className="rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <p className="max-w-xs font-bold text-black">
                          &ldquo;I can navigate daily conversations naturally&rdquo;
                        </p>
                        <p className="mt-4 text-sm text-gray-500">
                          Intensive Track
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="testimonial-wrapper text-start">
                    <div className="testimonialRight testimonialItem1">
                      <div className="rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <p className="max-w-xs font-bold text-black">
                          &ldquo;I can navigate daily conversations naturally&rdquo;
                        </p>
                        <p className="mt-4 text-sm text-gray-500">
                          Intensive Track
                        </p>
                      </div>
                    </div>
                    <div className="testimonialRight testimonialItem2">
                      <div className="rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <p className="max-w-xs font-bold text-black">
                          &ldquo;I moved from translating… to thinking in Arabic&rdquo;
                        </p>
                        <p className="mt-4 text-sm text-gray-500">
                          PhD Researcher
                        </p>
                      </div>
                    </div>
                    <div className="testimonialRight testimonialItem3">
                      <div className="rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <p className="max-w-xs font-bold text-black">
                          &ldquo;I present and negotiate in Arabic confidently&rdquo;
                        </p>
                        <p className="mt-4 text-sm text-gray-500">
                          Founder
                        </p>
                      </div>
                    </div>
                    <div className="testimonialRight testimonialItem4">
                      <div className="rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <p className="max-w-xs font-bold text-black">
                          &ldquo;I handle formal conversations without switching to English&rdquo;
                        </p>
                        <p className="mt-4 text-sm text-gray-500">
                          Diplomatic Mission
                        </p>
                      </div>
                    </div>
                    <div className="testimonialRight testimonialItem5">
                      <div className="rounded-3xl bg-white px-5 py-6 shadow-xl">
                        <p className="max-w-xs font-bold text-black">
                          &ldquo;I now contribute and lead discussions in Arabic&rdquo;
                        </p>
                        <p className="mt-4 text-sm text-gray-500">
                          Regional Director
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="xsm:mb-6 xsm:mt-0.5 mt-0.5 mb-6 flex flex-col items-center justify-center sm:mt-4 sm:mb-10 md:mt-9 md:mb-12 lg:mt-10 lg:mb-14 xl:mt-6 xl:mb-8">
                  <div className="xsm:gap-5 xsm:text-lg flex flex-col gap-5 text-base font-bold sm:gap-6 sm:text-xl md:flex-row md:gap-7 md:text-2xl lg:gap-8 lg:text-3xl xl:gap-9 xl:text-4xl">
                    {/* Feature Item: Smart Tools */}
                    <div className="xsm:gap-1 flex items-center gap-1 sm:gap-1.5 md:gap-2 lg:gap-2.5 xl:gap-3">
                      <div className="xsm:p-0.75 rounded-md border-2 border-[#F6C65A] bg-white p-0.5 sm:p-1 md:p-1.25 lg:p-1.5 xl:p-1">
                        <Image
                          src="/images/svg/check.svg"
                          alt="Check icon for Smart tools"
                          width={20}
                          height={20}
                          className="xsm:h-2.5 xsm:w-2.5 h-2.5 w-2.5 sm:h-3 sm:w-3 md:h-3.5 md:w-3.5 lg:h-[0.9rem] lg:w-[0.9rem] xl:h-5 xl:w-5"
                        />
                      </div>
                      <span className="xsm:text-base text-sm text-[#27335D] sm:text-lg md:text-xl lg:text-2xl xl:text-3xl">
                        Smart tools
                      </span>
                    </div>

                    {/* Feature Item: Expert Tutors */}
                    <div className="xsm:gap-1 flex items-center gap-1 sm:gap-1.5 md:gap-2 lg:gap-2.5 xl:gap-3">
                      <div className="xsm:p-0.75 rounded-md border-2 border-[#F6C65A] bg-white p-0.5 sm:p-1 md:p-1.25 lg:p-1.5 xl:p-1">
                        <Image
                          src="/images/svg/check.svg"
                          alt="Check icon for Expert tutors"
                          width={20}
                          height={20}
                          className="xsm:h-2.5 xsm:w-2.5 h-2.5 w-2.5 sm:h-3 sm:w-3 md:h-3.5 md:w-3.5 lg:h-[0.9rem] lg:w-[0.9rem] xl:h-5 xl:w-5"
                        />
                      </div>
                      <span className="xsm:text-base text-sm text-[#27335D] sm:text-lg md:text-xl lg:text-2xl xl:text-3xl">
                        Expert tutors
                      </span>
                    </div>

                    {/* Feature Item: Fun Learning */}
                    <div className="xsm:gap-1 flex items-center gap-1 sm:gap-1.5 md:gap-2 lg:gap-2.5 xl:gap-3">
                      <div className="xsm:p-0.75 rounded-md border-2 border-[#F6C65A] bg-white p-0.5 sm:p-1 md:p-1.25 lg:p-1.5 xl:p-1">
                        <Image
                          src="/images/svg/check.svg"
                          alt="Check icon for Fun learning"
                          width={20}
                          height={20}
                          className="xsm:h-2.5 xsm:w-2.5 h-2.5 w-2.5 sm:h-3 sm:w-3 md:h-3.5 md:w-3.5 lg:h-[0.9rem] lg:w-[0.9rem] xl:h-5 xl:w-5"
                        />
                      </div>
                      <span className="xsm:text-base text-sm text-[#27335D] sm:text-lg md:text-xl lg:text-2xl xl:text-3xl">
                        Fun learning
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Fifth Section */}
          <section className="bg-[#4887f5]">
            <div className="rounded-b-semifull xsm:pb-10 bg-[#E9E9EA] pb-10 sm:pb-12 md:pb-14 lg:pb-16 xl:pb-20">
              <div className="rounded-b-semifull xsm:py-10 relative bg-[#27335d] py-10 text-white sm:py-12 md:py-12 lg:py-14 xl:py-16">
                {/* Intro */}
                <div className="xsm:mb-6 mx-auto mb-6 flex w-[80%] flex-row items-center justify-start sm:mb-7 md:mb-8 lg:mt-8 lg:mb-9 xl:mt-10 xl:mb-10">
                  <div className="text-start">
                    <h1 className="xsm:text-xl pb-3 text-xl font-bold tracking-tight text-white sm:text-2xl md:pb-8 md:text-5xl lg:text-6xl xl:text-7xl">
                      Proudly Supported By
                    </h1>
                  </div>
                </div>
                {/* Logos */}
                <div className="xsm:p-4 mx-auto flex w-fit flex-col items-center justify-center gap-6 rounded-3xl border-4 border-[#4887F5] bg-white p-4 sm:p-5 md:max-w-[85%] md:flex-row md:gap-8 md:p-6 lg:gap-10 lg:p-8 xl:p-10">
                  {/* Logo 1 */}
                  <div className="xsm:pb-2 flex items-center pb-2 sm:pb-4 md:pb-0">
                    <Image
                      src="/images/Logos/misklogo.svg"
                      alt="Misk"
                      width={100}
                      height={100}
                      quality={100}
                      priority={true}
                      loading="eager"
                      className="xsm:w-36 w-28 sm:w-44 md:w-60 lg:w-72 xl:w-80"
                    />
                  </div>

                  {/* Divider */}
                  <div className="hidden h-24 w-px bg-[#4887F5] md:block lg:h-28 xl:h-36"></div>
                  <div className="block w-full border-t border-[#4887F5] md:hidden"></div>

                  {/* Logo 2 */}
                  <div className="xsm:py-2 flex items-center py-2 sm:py-4 md:py-0">
                    <Image
                      src="/images/Logos/2030visionlogo.svg"
                      alt="2030 Vision"
                      width={100}
                      height={100}
                      quality={100}
                      priority={true}
                      loading="eager"
                      className="xsm:w-28 w-24 sm:w-36 md:w-40 lg:w-48 xl:w-52"
                    />
                  </div>

                  {/* Divider */}
                  <div className="hidden h-24 w-px bg-[#4887F5] md:block lg:h-28 xl:h-36"></div>
                  <div className="block w-full border-t border-[#4887F5] md:hidden"></div>

                  {/* Logo 3 */}
                  <div className="xsm:pt-2 flex items-center pt-2 sm:pt-4 md:pt-0">
                    <Image
                      src="/images/Logos/ntdplogo.svg"
                      alt="NTDP"
                      width={100}
                      height={100}
                      quality={100}
                      priority={true}
                      loading="eager"
                      className="xsm:w-36 w-28 sm:w-44 md:w-60 lg:w-72 xl:w-80"
                    />
                  </div>
                </div>
                {/* Call to Action */}
                <div className="xsm:mt-10 mt-10 flex flex-col items-center px-10 text-center sm:mt-12 md:mt-14 lg:items-start lg:text-start">
                  <p className="mx-auto w-full max-w-[83%] text-xl font-semibold sm:text-2xl md:text-3xl lg:text-start lg:text-3xl">
                    Join Our Network of Amazing Supporters, Let's Connect!
                  </p>
                </div>
                {/* Button */}
                <div className="mt-10 flex justify-center pb-10 lg:mt-16">
                  <Link href="/help#contactForm" data-testid="homeContactUsButton" className="inline-block transform-gpu rounded-full border-b-8 border-black bg-[#4887F5] px-10 py-4 text-xl font-bold text-[#27335d] shadow-2xl transition-all duration-300 ease-out hover:bg-[#3666b9] active:scale-95 sm:px-16 sm:py-5 sm:text-2xl md:px-24 md:py-6 md:text-3xl">
                      Contact us
                  </Link>
                </div>
              </div>
            </div>
          </section>
          {/* Sixth Section */}
          <section>
            <div className="rounded-b-semifull xsm:pb-6 bg-[#E9E9EA] pb-6 sm:pb-8 md:pb-10 lg:pb-12 xl:pb-14">
              <div className="rounded-b-semifull xsm:py-8 relative bg-[#4887f5] py-8 text-white sm:py-10 md:py-12 lg:py-12 xl:py-14">
                {/* Intro */}
                <div className="text-center">
                  <h1 className="z-20 text-3xl font-bold tracking-tight text-white md:text-4xl">
                    Reach Out Anytime, Anywhere
                  </h1>
                </div>
                <div className="mt-6 flex flex-wrap justify-center gap-5 md:mt-12">
                  <div className="z-20 flex flex-col items-center justify-center rounded-full bg-[#27335D] p-2 text-center text-xl text-white md:p-3 md:text-3xl">
                    <a href="https://wa.me/966557319070" target="_blank" data-testid="homeWhatsappLink">
                      <FaWhatsapp />
                    </a>
                  </div>
                  <div className="z-20 flex flex-col items-center justify-center rounded-full bg-[#27335D] p-2 text-center text-xl text-white md:p-3 md:text-3xl">
                    <a
                      href="https://www.linkedin.com/company/rawiah"
                      target="_blank"
                      data-testid="homeLinkedinLink"
                    >
                      <FaLinkedin />
                    </a>
                  </div>
                  <div className="z-20 flex flex-col items-center justify-center rounded-full bg-[#27335D] p-2 text-center text-xl text-white md:p-3 md:text-3xl">
                    <a href="https://x.com/rawiah_ar" target="_blank" data-testid="homeTwitterLink">
                      <FaXTwitter />
                    </a>
                  </div>
                  <div className="absolute right-[5%] bottom-[46.5%] translate-y-1/2 transform">
                    <Image
                      src="/images/svg/line3.svg"
                      alt="Line"
                      width={120}
                      height={120}
                      className="z-10 h-12 w-auto object-contain sm:h-14 md:h-20 lg:h-32"
                    />
                  </div>
                  <div className="absolute bottom-[45%] left-[3%] translate-y-1/2 transform">
                    <Image
                      src="/images/svg/line4.svg"
                      alt="Line"
                      width={130}
                      height={130}
                      className="z-10 h-12 w-auto object-contain sm:h-14 md:h-20 lg:h-32"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
